import React from 'react';
import { Card, Typography, Button, Space } from 'antd';
import { PlusOutlined, ExclamationCircleOutlined, SmileOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const NoAuctionsFound = ({
    title = "No Auctions Found",
    description = "You need to create an auction before you can add lots.",
    buttonText = "Create Your First Auction",
    onButtonClick,
    buttonIcon = <PlusOutlined />,
    customButtonAction
}) => {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        if (customButtonAction) {
            customButtonAction();
        } else {
            navigate('/auctions/create');
        }
    };

    return (
        <Card
            style={{
                textAlign: 'center',
                padding: '40px',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
            }}
        >
            <ExclamationCircleOutlined style={{ fontSize: '48px', color: '#faad14', marginBottom: '16px' }} />
            <Title level={4}>{title}</Title>
            <Text type="secondary" style={{ display: 'block', marginBottom: '24px' }}>
                {description}
            </Text>
            <Space direction="vertical" size={12}>
                <Button
                    type="primary"
                    icon={buttonIcon}
                    onClick={handleButtonClick}
                >
                    {buttonText}
                </Button>
                <Button
                    type="link"
                    icon={<SmileOutlined />}
                    onClick={() => navigate('/auctions/easy-create')}
                >
                    Try Easy Mode instead (simple, step-by-step)
                </Button>
            </Space>
        </Card>
    );
};

export default NoAuctionsFound; 